var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQamMyBets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3658_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4427 4.40625L16.9271 0.890625C16.3646 0.328125 15.6146 0 14.8177 0H6.33334C4.64584 0 3.33334 1.35938 3.33334 3V21C3.33334 22.6875 4.64584 24 6.33334 24H18.3333C19.974 24 21.3333 22.6875 21.3333 21V6.51562C21.3333 5.71875 21.0052 4.96875 20.4427 4.40625ZM19.0833 21C19.0833 21.4219 18.7083 21.75 18.3333 21.75H6.33334C5.91147 21.75 5.58334 21.4219 5.58334 21V3.04688C5.58334 2.625 5.91147 2.29688 6.33334 2.29688H13.8333V6C13.8333 6.84375 14.4896 7.5 15.3333 7.5H19.0365V21H19.0833ZM7.83334 6H11.5833C11.9583 6 12.3333 5.67188 12.3333 5.25C12.3333 4.875 11.9583 4.5 11.5833 4.5H7.83334C7.41147 4.5 7.08334 4.875 7.08334 5.25C7.08334 5.67188 7.41147 6 7.83334 6ZM12.3333 8.25C12.3333 7.875 11.9583 7.5 11.5833 7.5H7.83334C7.41147 7.5 7.08334 7.875 7.08334 8.25C7.08334 8.67188 7.41147 9 7.83334 9H11.5833C11.9583 9 12.3333 8.67188 12.3333 8.25ZM12.5677 14.4844L12.2865 14.4375C11.2083 14.1094 11.2083 13.9219 11.2552 13.7344C11.3021 13.3594 12.0521 13.2656 12.6615 13.3594C12.9427 13.4062 13.224 13.5 13.5052 13.5938C13.974 13.7812 14.5365 13.5 14.6771 13.0312C14.8646 12.5156 14.6302 12 14.1146 11.8125C13.7865 11.7188 13.5052 11.625 13.2708 11.5781V11.25C13.2708 10.7344 12.849 10.3125 12.3333 10.3125C11.7708 10.3125 11.3958 10.7344 11.3958 11.25V11.5312C10.3177 11.7656 9.56772 12.4219 9.42709 13.4062C9.05209 15.4219 10.974 15.9844 11.7708 16.2188L12.0521 16.3125C13.4115 16.6875 13.4115 16.8281 13.3646 17.0625C13.3177 17.4375 12.5677 17.5312 11.9583 17.4375C11.6302 17.3906 11.2083 17.2031 10.8333 17.1094L10.6458 17.0156C10.1302 16.8281 9.61459 17.1094 9.42709 17.5781C9.23959 18.0938 9.52084 18.6094 9.98959 18.7969L10.1771 18.8438C10.5521 18.9844 10.974 19.125 11.3958 19.2188V19.5C11.3958 20.0625 11.7708 20.4375 12.3333 20.4375C12.849 20.4375 13.2708 20.0625 13.2708 19.5V19.2188C14.3021 18.9844 15.0521 18.375 15.1927 17.3906C15.5677 15.3281 13.599 14.8125 12.5677 14.4844Z",
    fill: "#EDF2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3658_682",
    x: 0.333344,
    y: 0,
    width: 24,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3658_682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3658_682",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3658_682"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQamMyBets);
export default ForwardRef;